import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const sextingAnonymousBase: BrandBase = {
  id: `sextingAnonymous`,
  domain: `sextinganonymous.com`,
  email: `support@sextinganonymous.com`,
  theme: `purple`,
  backgroundId: `passionate`,
  adsenseId: null,
  micrositeTheme: createMicrositeTheme({
    id: `sextingAnonymous`,
    name: `Sexting Anonymous Microsite`,
    palette: {
      primary: `#a855f7`,
      secondary: `#6b46c1`,
      accent: `#c084fc`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #6b46c1, #a855f7)`,
      sectionLight: `linear-gradient(135deg, rgba(247, 243, 255, 0.96), rgba(237, 233, 254, 0.92))`,
      sectionDark: `linear-gradient(160deg, #130720, #1f0e2f 45%, #2e0f3d 90%)`,
      primaryCta: `linear-gradient(120deg, #a855f7, #c084fc 50%, #f472b6 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #a855f7, #c084fc 50%, #f472b6 100%)`,
        glow: `rgba(168, 85, 247, 0.45)`,
        shadow: `0 32px 70px rgba(168, 85, 247, 0.4)`,
      },
    },
  }),
  manifest: {
    name: `Sexting Anonymous - Private Anonymous Sexting | No Registration Required`,
    short_name: `SextingAnonymous`,
    description: `Completely anonymous sexting platform. Private conversations with full anonymity and instant connections.`,
    theme_color: `#6b46c1`,
    background_color: `#ffffff`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://sextinganonymous.com`,
    uat: `https://dev.sextinganonymous.com`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  hostRedirects: {
    'www.sextinganonymous.com': `sextinganonymous.com`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `anonymous sexting, private sexting, sexting platform, anonymous chat, private messaging, no registration sexting, instant connect, SextingAnonymous`,
    author: `SextingAnonymous`,
  },
  social: {
    title: `Sexting Anonymous - Private Anonymous Sexting`,
    image: `/icon.png`,
  },
};
